var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrowButtonDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 60,
    viewBox: "0 0 66 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_6640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 0.5,
    width: 59,
    height: 64.5025,
    transform: "rotate(90 65.5 0.5)",
    fill: "#D9D9D9",
    stroke: "#7B7B7B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_6640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3485 17.8658L34.3401 17.858L34.3317 17.8658L11.8918 38.4206L7.06589 34L34.3401 9.01695L61.6143 34L56.7884 38.4205L34.3485 17.8658Z",
    fill: "#BBBBBB",
    stroke: "#7B7B7B",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowButtonDisabled);
export default __webpack_public_path__ + "static/media/upArrowButtonDisabled.7617f52aeaa7b6d1e271214769887614.svg";
export { ForwardRef as ReactComponent };